module.exports = __webpack_public_path__ + "static/media/bulle-peau-lisse.404ef6e4.png";